import { BannerModel } from './Banner'
import CreativeApi from '@/api/Creative'
import { BulkActionError } from './Error'
import { runInBatches } from '@/models/runInBatches'

export class BannerRepository {
  static async get(id) {
    try {
      const res = await CreativeApi.getBanner(id)
      return BannerModel.assign(res.item)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async bulkCreate(creatives) {
    try {
      const results = await runInBatches(
        creatives.map(creative => () => CreativeApi.createBanner(creative)),
      )
      return results.map(result => BannerModel.assign(result.item))
    } catch (e) {
      console.log(e)
      console.log(e.error.response.data.errorMessage)
      const error =
        e.error.response.data.errorMessage ===
        'SYNTAX : click_uri is not valid '
          ? new BulkActionError(
              'URLが不正です。半角空白、空白などが含まれていないかを確認して、',
            )
          : new BulkActionError(
              '一括変更に失敗しました。一部完了できていない操作があります。',
            )
      console.log(error)
      // 全てのエラーと成功オブジェクトを返す
      error.errors = e.errors
      error.results = e.results.map(result => BannerModel.assign(result.item))
      throw error
    }
  }

  static async update(data) {
    try {
      const result = await CreativeApi.updateBanner(data.id, data)
      return BannerModel.assign(result.item)
    } catch (e) {
      console.error(e)
      throw e
    }
  }
}
